module.exports = __webpack_public_path__ + "ae97cfc571d8c0a28561f99f69975f58.pdf";